import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, NgZone, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list'
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { Platform } from '@angular/cdk/platform';

export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'DD/MM/YYYY') {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return super.format(date, displayFormat);
  }

  override parse(value: any): Date | null {
    if (typeof value === 'string' && value.length > 0) {
      const parts = value.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Los meses van de 0-11
        const year = parseInt(parts[2], 10);
        
        if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
          const date = new Date(year, month, day);
          // Verificar que la fecha sea válida
          if (date.getFullYear() === year && date.getMonth() === month && date.getDate() === day) {
            return date;
          }
        }
      }
    }
    return super.parse(value);
  }
}
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../../shared/services/loader.service';
import { SearchRequest } from '../models/search-request.model';
import { SearchService } from '../services/search.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { MatSelectModule } from '@angular/material/select';
import { SearchResponse } from '../models/search-response.model';
import { RegisterService } from '../services/register.service';
import { RegisterRequest } from '../models/register-request.model';
import { ThemeService } from '../../../shared/services/theme.service';
import { MatRadioButton } from '@angular/material/radio';
import { searchBanamexRequest } from '../models/search-banamex-request-model';
import { BanamexResponse } from '../models/search-banamex-response-model';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatGridListModule,
    MatListModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatSelectModule,

  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss',
  providers: [
    DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
      deps: [MAT_DATE_LOCALE, Platform]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'DD/MM/YYYY',
        },
        display: {
          dateInput: 'DD/MM/YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'DD/MM/YYYY',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,

})

export class RegisterComponent implements OnInit {
  @ViewChild('telefonoAdicionalInput') telefonoAdicionalInput!: ElementRef;
  
  private readonly TENANT_ID = 'adff7f6a-e97d-11eb-9a03-0242ac130003';
  private readonly APP_NAME = 'PortalAsistencia';
  private readonly SPONSOR = '536';
  private readonly MEMBERSHIPS = '5555555';
  
  registerForm!: FormGroup;
  searchForm!: FormGroup;

  date: any;
  minDate!: Date;
  maxDate!: Date;

  ladaList = [
    { name: '+1', img: 'https://flagcdn.com/w40/us.png' },
    { name: '+52', img: 'assets/flags/mx.svg' },
    { name: '+57', img: 'https://flagcdn.com/w40/co.png' }
  ];

  selectedLadaTelPrimary: any;
  selectedLadaTelSecondary: any;

  hidePassword = true;
  hideConfirm = true;

  emailPattern = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

  nameFieldSearch = 'Número de póliza';
  uuidClient:number = 0;
  
  wasFound = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loader: LoaderService,
    private searchService: SearchService,
    private registerService: RegisterService,
    private notificationService: NotificationService,
    private datePipe: DatePipe,
    private route:ActivatedRoute,
    private cd: ChangeDetectorRef,
    private themeService: ThemeService
  ) {  
  }

  ngOnInit(): void {
    // Configurar fechas mínima y máxima para el datepicker
    const today = new Date();
    this.maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    this.minDate = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate());
    
    // Scroll hacia arriba al cargar la página
    window.scrollTo(0, 0);
    
    // Establecer valores por defecto para códigos de país
    this.selectedLadaTelPrimary = this.ladaList[1]; // +52 México
    this.selectedLadaTelSecondary = this.ladaList[1]; // +52 México
    
    this.registerForm = this.fb.group({
      cuenta: ['', Validators.required],
      fecha_vigencia_inicio: ['', Validators.required],
      fecha_vigencia_fin: ['', Validators.required],
      fecha_nacimiento: [null, Validators.required],
      nombre_completo: ['', Validators.required],
      correo: ['', [Validators.required, Validators.pattern(this.emailPattern), Validators.email]],
      telefono_movil: ['', [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(10), Validators.maxLength(10)]],
      correo_adicional: ['', Validators.pattern(this.emailPattern)],
      telefono_movil_adicional: ['', [Validators.pattern(/^[0-9]*$/), Validators.minLength(10), Validators.maxLength(10)]],
      password: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
      options: this.fb.group({
        contactMethod: ['', Validators.required]
      }),
      aviso_privacidad: [false, [Validators.requiredTrue]],
      terminos_condiciones: [false, [Validators.requiredTrue]]
    }, { validators: this.passwordsMatch });
    
    this.searchForm = this.fb.group({
      numero_empleado: ['', Validators.required],
      correo_electronico: ['']
    });
    
    // Una sola suscripción a queryParams
    this.loader.show();
    this.route.queryParams.subscribe(params => {
      this.uuidClient = parseInt(params['uuidc'] == undefined ? 536: params['uuidc']);
      
      // Configurar validaciones condicionales
      if ([2228, 2665, 2559, 2907, 2988].includes(this.uuidClient)) {
        this.searchForm.get('correo_electronico')?.setValidators([Validators.required, Validators.email]);
      } else {
        this.searchForm.get('correo_electronico')?.clearValidators();
      }
      this.searchForm.get('correo_electronico')?.updateValueAndValidity();
      
      // Cargar configuración
      if (this.uuidClient > 0) {
        this.getLoadConfigurationByAccount();
      } else {
        this.setValueFieldSearch("Número de empleado");
        this.loader.hide();
      }
    });
    
    // Interceptar emails en campo de teléfono adicional
    this.registerForm.get('telefono_movil_adicional')?.valueChanges.subscribe(value => {
      if (value && value.includes('@')) {
        // Limpiar completamente el campo
        const control = this.registerForm.get('telefono_movil_adicional');
        control?.setValue('', { emitEvent: false });
        control?.setErrors(null);
        control?.markAsUntouched();
        control?.markAsPristine();
        
        // Asignar email al campo correcto
        if (!this.registerForm.get('correo')?.value) {
          this.registerForm.get('correo')?.setValue(value, { emitEvent: false });
        }
        
        // Forzar limpieza visual directa del input
        setTimeout(() => {
          if (this.telefonoAdicionalInput?.nativeElement) {
            this.telefonoAdicionalInput.nativeElement.value = '';
            this.telefonoAdicionalInput.nativeElement.blur();
          }
          this.cd.detectChanges();
        }, 0);
      }
    });

    if (history.state.data != null) {
      let dataFromErrorDataComponent = history.state.data;
      this.loadData(dataFromErrorDataComponent);
    }
   
    
  }
  // Accessors
  get password() {
    return this.registerForm.get('password')?.value || '';
  }

  get mismatch() {
    return this.registerForm.errors?.['mismatch'];
  }

  get passwordControl() {
    return this.registerForm.get('password');
  }

  get confirmPasswordControl() {
    return this.registerForm.get('confirmPassword');
  }



  // Custom validator
  passwordsMatch(group: FormGroup): null | { mismatch: true } {
    const passwordControl = group.get('password');
    const confirmControl = group.get('confirmPassword');

    if (!passwordControl || !confirmControl) return null;

    const password = passwordControl.value;
    const confirm = confirmControl.value;

    if (password === confirm) {
      confirmControl.setErrors(null);
      return null;
    } else {
      confirmControl.setErrors({ mismatch: true });  // assign error to control
      return { mismatch: true };                     // assign error to group (optional)
    }
  }





  // Strength checks
  hasMinLength = () => this.password.length >= 8;
  hasNumber = () => /\d/.test(this.password);
  hasUppercase = () => /[A-Z]/.test(this.password);
  hasSpecialChar = () => /[@$!%*?&#+\-_]/.test(this.password);
  passwordsAreMatching = () => this.registerForm.errors === null;

  //Submit event
  onSearchSubmit(): void {
    if (this.searchForm.invalid) return;
    
    // Redirección para cuentas de Banamex
    if ([2228, 2665, 2559, 2907, 2988].includes(this.uuidClient)) {
      this.router.navigate(['/code-banamex'], {
        queryParams: {
          correo: this.searchForm.value.correo_electronico,
          poliza: this.searchForm.value.numero_empleado,
          uuidc: this.uuidClient
        }
      });
      return;
    }
    
    this.loader.show();
    const searchPayload: SearchRequest = {
      identifier: {
        tenants: this.TENANT_ID,
        app: this.APP_NAME
      },
      petition: {
        key: this.searchForm.value.numero_empleado,
        sponsor: this.SPONSOR,
      }
    }

    this.searchService.searchAfilliate(searchPayload).subscribe({
      next: (response) => {
        this.loader.hide();
        if (response.response.results.length > 0) {
          this.loadData(response);
        } else {
          this.goToValidate();
        }
        this.clearDataState();
      },
      error: (err) => {
        this.loader.hide();
        this.goToValidate();
        this.clearDataState();
      }
    });
  }

  onRegisterSubmit(): void {
    if (this.registerForm.valid) {
      this.loader.show();
      
      const { options } = this.registerForm.value;
      const contactMeans = options.contactMethod || "0";
      const formData = this.registerForm.value;
      const formattedDate = this.datePipe.transform(formData.fecha_nacimiento, 'yyyy-MM-dd');
      const registerPayload: RegisterRequest = {
        identifier: {
          tenants: this.TENANT_ID,
          app: this.APP_NAME
        },
        petition: {
          account: parseInt(formData.cuenta),
          email: formData.correo,
          fullName: formData.nombre_completo,
          memberships: this.searchForm.value.numero_empleado,
          startDate: `${formData.fecha_vigencia_inicio} 00:00:00`,
          endDate: `${formData.fecha_vigencia_fin} 00:00:00`,
          birthdate: formattedDate || '',
          additionalEmail: formData.correo_adicional || '',
          phone: parseInt(formData.telefono_movil),
          additionalPhone: formData.telefono_movil_adicional ? parseInt(formData.telefono_movil_adicional) : 0,
          contactMeans: parseInt(contactMeans),
          privancyNoticeAcceptance: formData.aviso_privacidad.toString(),
          acceptanceTermsConditions: formData.terminos_condiciones.toString(),
          password: formData.password
        }
      }
      console.log(registerPayload)
      
      this.registerService.userAdd(registerPayload).subscribe({
        next: (response) => {
          this.loader.hide();
          if (response.code == 200) {
            this.notificationService.showSuccess(
              'Su registro ha sido creado exitosamente. ¡Bienvenido!', 
              '¡Registro Exitoso!',
              () => this.goToHome()
            );
          } else if (response.code == 409) {
            this.notificationService.showError('El usuario ya existe. Por favor, inicie sesión o use un correo diferente.', 'Usuario Existente');
          } else {
            this.notificationService.showError(response.message || 'Error al crear el registro. Intente nuevamente.');
          }
          this.clearDataState();
        },
        error: (err) => {
          this.loader.hide();
          if (err.error?.code == 409) {
            this.notificationService.showError('El usuario ya existe. Por favor, inicie sesión o use un correo diferente.', 'Usuario Existente');
          } else {
            this.notificationService.showError('Error al procesar el registro. Verifique su conexión e intente nuevamente.');
          }
        }
      });
    }
  }

  // utils
  loadData(response: SearchResponse) {
    this.registerForm.reset();
    const fieldMap: { [key: string]: string } = {
      'account': 'cuenta',
      'fullName': 'nombre_completo',
      'startDate': 'fecha_vigencia_inicio',
      'endDate': 'fecha_vigencia_fin'
    };
    
    response.response.results[0].forEach(element => {
      const fieldName = element.fieldName.toString();
      const mappedField = fieldMap[fieldName];
      if (mappedField) {
        const value = fieldName.includes('Date') ? element.fieldValue.slice(0, 10) : element.fieldValue;
        this.registerForm.patchValue({ [mappedField]: value });
        
        if (fieldName === 'account') {
          this.setValueWasFoundSearch(true);
        }
      } else if (fieldName === 'email' && element.fieldValue?.includes('@')) {
        this.registerForm.patchValue({ 'correo': element.fieldValue });
      } else if (fieldName === 'phone' && element.fieldValue && !element.fieldValue.includes('@')) {
        this.registerForm.patchValue({ 'telefono_movil': element.fieldValue });
      } else if (fieldName === 'key'){
        this.searchForm.patchValue({'numero_empleado': element.fieldValue })
      }
    });
  }

  setValueFieldSearch(value:string):void{
    setTimeout(() => {
      if ([2228, 2665, 2559, 2907, 2988].includes(this.uuidClient)) {
        this.nameFieldSearch = "Número de póliza";
      } else {
        this.nameFieldSearch = value;
      }
      this.cd.detectChanges();
    }, 500); 
  }

  setValueWasFoundSearch(value:boolean):void{
    if (this.wasFound !== value) {
      this.wasFound = value;
      this.cd.markForCheck();
      this.cd.detectChanges();
    }
  }
  getLoadConfigurationByAccount():void{
    this.searchService.loadConfig(this.uuidClient).subscribe({
      next: (response) => {
        localStorage.setItem('uuidClient', this.uuidClient.toString());
        this.loader.hide();
        this.themeService.applyTheme(response.theme);
        if (response?.success) {
          this.setValueFieldSearch(response.account.key.description);
        }
        this.cd.detectChanges();
      },
      error: (err) => {
        this.setValueFieldSearch("Número de empleado");
        this.loader.hide();
        this.cd.detectChanges();
      }
    });
  }

  clearDataState(): void {
    history.replaceState({}, '', window.location.href);
  }
  // Redirects
  goToValidate(): void {
    this.router.navigate(['/error-data'], {
      queryParams: { uiidc: this.uuidClient }
    });
  }
  goToHome(): void {
    this.router.navigate(['']);
  }

  getImageSource(): string {
    const basePath = 'assets/images/';
    const imageName = this.wasFound ? 'register-img.svg' : 'register_one.png';
    return `${basePath}${imageName}`;
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  onLoginRedirect(): void {
    this.router.navigate(['/'], {
      queryParams: { uuidc: this.uuidClient }
    });
  }


  
}
